(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/announcement/assets/javascripts/announcement.js') >= 0) return;  svs.modules.push('/widgets/announcement/assets/javascripts/announcement.js');

var svs = svs || {};

(function(svs, _) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.announcement = svs.widget.announcement || {};
  svs.widget.announcement.init = function(model) {
    if (
      _.isObject(model) &&
      _.isArray(model.announcements) &&
      model.announcements.length > 0
    ) {
      var announcement = model.announcements[0];
      var dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding[svs.core.detect.tenant('lb') ? 'SPORT' : 'TUR'],
        type: svs.ui.dialog.type.ERROR,
        title: announcement.title || '',
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text: announcement.message || ''
          }
        ],
        actions: [
          {
            title: announcement.buttons && announcement.buttons[0] && announcement.buttons[0].text ? announcement.buttons[0].text : 'Okej'
          }
        ]
      });
      svs.ui.dialog.api.add(dialog);
    }
  };
})(svs, _);


 })(window);